import React from 'react';
import { withStyles } from 'tss-react/mui';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

const styles = {
  cardContent: {
    maxWidth: 500,
    margin: 10,
    border: '1px solid lightgrey',
    borderRadius: 5,
  },
  typography: {
    padding: 5,
  },
};

const ArchiveInfoDisplay = ({ user, date, reason, classes }) => (
  <Card>
    <CardContent className={classes.cardContent}>
      <Typography variant="h5">
        Archivé par {user} le {date}
      </Typography>
      <Typography variant="body1" className={classes.typography}>
        {reason}
      </Typography>
    </CardContent>
  </Card>
);

export default withStyles(ArchiveInfoDisplay, styles);
